import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14f53490"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["layout"]
const _hoisted_2 = { class: "relation-text-area" }
const _hoisted_3 = { class: "relation-path-visual" }
const _hoisted_4 = { class: "relation-arm-area" }
const _hoisted_5 = {
  key: 0,
  class: "relation-arm list-unstyled"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "parent-connector" }, null, -1))
const _hoisted_7 = {
  key: 1,
  class: "relation-arm list-unstyled"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "parent-connector" }, null, -1))
const _hoisted_9 = { class: "common-ancestor-area" }
const _hoisted_10 = {
  key: 0,
  class: "relation-arm-connector"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "horizontal-bar" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vertical-bar" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "horizontal-bar" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "family-dot" }, null, -1))
const _hoisted_15 = [
  _hoisted_11,
  _hoisted_12,
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = {
  key: 1,
  class: "common-ancestor-family"
}

import { computed, ref, watch } from 'vue'
import { useViewPersonStore } from '@/rd/ViewPersonStore'
import { useExploreStore } from './ExploreStore'
import { useRelationTextBuilder } from '@/rd/RelationPath'
import PersonCard from '@/manage/PersonCard.vue'
import FamilyCard from '@/manage/FamilyCard.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'RelationPath',
  props: {
    personId: {}
  },
  setup(__props: any) {

const props = __props;



const viewPersonStore = useViewPersonStore()
const exploreStore = useExploreStore()
const { getRelationText } = useRelationTextBuilder()

const startPersonIdRef = computed(() => exploreStore.startPersonId)
const isSelfRef = computed(() => exploreStore.relationPath && 
  (exploreStore.relationPath.startPersonPath.length == 0 && 
   exploreStore.relationPath.toPersonPath.length == 0))

const showFullRef = ref(false)
const cardLayoutRef = computed(() => showFullRef.value ? 'tiny' : 'dot')

const hasUpPathRef = computed(() => (exploreStore.relationPath?.startPersonPath.length ?? 0) > 0)
const hasDownPathRef = computed(() => (exploreStore.relationPath?.toPersonPath.length ?? 0) > 0)
const lastUpPathFamilyIdRef = computed(() => exploreStore.relationPath?.startPersonPath.at(-1)?.parentFamilyId)
const lastDownPathFamilyIdRef = computed(() => exploreStore.relationPath?.toPersonPath.at(-1)?.parentFamilyId)
const commonAncestorFamilyIdRef = computed(() => hasUpPathRef.value && lastUpPathFamilyIdRef.value === lastDownPathFamilyIdRef.value ? lastUpPathFamilyIdRef.value : undefined)

watch([props, startPersonIdRef], async () => {
  exploreStore.relationPath = undefined

  if (!startPersonIdRef.value || !props.personId) {
    console.log(`RelationPath: no startPersonId and/or personId`)
    return
  }

  // TODO: check if relation path known for previous person. If known not to exist, and new person is a
  // child or parent of previous person, conclude relation path does not exist for new person either.

  let path = viewPersonStore.getLoadedRelationPath(startPersonIdRef.value, props.personId)
  console.log(`RelationPath loaded: ${!!path}`)
  if (!path) {
    await viewPersonStore.ensureRelationPathsLoadedAsync(startPersonIdRef.value, [props.personId])
    path = viewPersonStore.getLoadedRelationPath(startPersonIdRef.value, props.personId)
    console.log(`RelationPath loaded: ${!!path}`)
  }

  exploreStore.relationPath = path
}, { immediate: true})

function showAsCurrent(personId: string) {
  return showFullRef.value && personId == props.personId
}


return (_ctx: any,_cache: any) => {
  return (_unref(exploreStore).relationPath)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "relation-path",
        layout: showFullRef.value ? 'full' : 'dot'
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-inline btn-link link-secondary relation-text",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showFullRef.value = !showFullRef.value))
          }, [
            _createElementVNode("div", null, "your " + _toDisplayString(_unref(getRelationText)(_unref(exploreStore).relationPath)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          (!showFullRef.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "overlay",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (showFullRef.value = true))
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            (hasUpPathRef.value)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(exploreStore).relationPath.startPersonPath, (pi) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: pi.ancestorId
                    }, [
                      _createVNode(PersonCard, {
                        personId: pi.ancestorId,
                        layout: cardLayoutRef.value,
                        raised: showAsCurrent(pi.ancestorId)
                      }, null, 8, ["personId", "layout", "raised"]),
                      _hoisted_6
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (hasDownPathRef.value)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(exploreStore).relationPath.toPersonPath, (pi) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: pi.ancestorId
                    }, [
                      _createVNode(PersonCard, {
                        personId: pi.ancestorId,
                        layout: cardLayoutRef.value,
                        raised: showAsCurrent(pi.ancestorId)
                      }, null, 8, ["personId", "layout", "raised"]),
                      _hoisted_8
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            (hasUpPathRef.value && hasDownPathRef.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_15))
              : _createCommentVNode("", true),
            (commonAncestorFamilyIdRef.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createVNode(FamilyCard, {
                    familyId: commonAncestorFamilyIdRef.value,
                    layout: cardLayoutRef.value,
                    "no-connector": ""
                  }, null, 8, ["familyId", "layout"])
                ]))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList([_unref(exploreStore).relationPath.commonAncestorId], (id) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "common-ancestor",
                    key: id
                  }, [
                    _createVNode(PersonCard, {
                      personId: id,
                      layout: cardLayoutRef.value,
                      raised: showAsCurrent(id)
                    }, null, 8, ["personId", "layout", "raised"])
                  ]))
                }), 128))
          ])
        ])
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})